module.exports = __webpack_public_path__ + "static/media/password_icon.7803e063.svg";